<template>
    <button @click.prevent="exportTabWidgets" class="btn btn-outline-secondary">{{resource('Shared_Export')}}</button>
</template>

<script>
import {createNamespacedHelpers} from 'vuex';
import api from "@modules/JourneyBuilder/api";
import loader from "@core/Util/loader";
import {bootstrapDangerGrowl} from "@core/Util/growler";

import resourceMixin from "@core/Util/Mixins/resources";

const {mapGetters, mapActions} = createNamespacedHelpers('journeyBuilder/reporting');

export default {
    name: "ExportTabButton",
    mixins: [resourceMixin],
    methods: {
        async exportTabWidgets() {
            try {
                const anchor = document.createElement('a');
                
                try {
                    loader.showProgressCursor();

                    //https://randomtutes.com/2019/08/02/download-blob-as-file-in-javascript/
                    const {report, filename} = await api.exportReportStatisticsTab(this.brickId, this.tabId, this.reportStatisticsParameters);
                    
                    document.body.append(anchor);

                    anchor.download = filename;
                    anchor.href = window.URL.createObjectURL(report);
                    anchor.click();
                } finally {
                    anchor.remove();

                    loader.stopProgressCursor();
                }
            } catch (e){
                bootstrapDangerGrowl(e);
            }
        }
    },
    computed: {
        ...mapGetters(['reportStatisticsParameters'])
    },
    props: {
        tabId: {
            type: Number,
            required: true
        },
        brickId: {
            type: String,
            required: true
        }
    }
}
</script>
